import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=c58e21fa&scoped=true"
import script from "./TransferDialog.vue?vue&type=script&lang=js"
export * from "./TransferDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferDialog.vue?vue&type=style&index=0&id=c58e21fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58e21fa",
  null
  
)

export default component.exports